import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class BeautyInMaking extends React.PureComponent<BeautyInMaking.Props, BeautyInMaking.State> {
  public static sectionId = 'beautyinmaking';
  public render(): JSX.Element {    
    const { section } = this.props
    const { settings } = section
   
    return (
      <section className={'dynamic-beauty-in-making py-4'} style={{background: settings['bg-color']}}>
        <div className={'max-w-8xl sm:px-2-4 2xl:px-22 xl:px-2-8 px-1-6 mx-auto'}>          
          <div className={'flex sm:flex-row flex-col sm:flex-nowrap flex-wrap sm:-mx-1-2'}>

            <Snippets.Heading tag="h3" className={'w-full font-bold font-sans uppercase leading-tight mb-3 px-1-6 '}>
              { settings.heading }
            </Snippets.Heading>

            {this.props.section?.blocks.map((block, i) => {
              const imageSrc = block.settings?.image
              const content = block.settings?.content
              const containerWidth = i == 0? 'sm:pr-2 sm:pl-10 sm:mt-25 md:pl-20' : i == 1? 'sm:pl-8' : i == 2? 'sm:pr-8' : 'sm:mt-10 sm:pl-2 sm:pr-10 md:pr-20'
          
              return (
                <div className={`artist-wrapper w-full mb-4 sm:w-1/2 md:mb-8 ${containerWidth}`}>

                  { imageSrc 
                    // @ts-ignore
                    ? <div key={i} style={{ '--x-max-height': block.settings.max_image_height + 'px', '--x-max-width': block.settings.max_image_width + 'px'}} className={`${this.props.section.blocks.length === 2 ? 'pl-0 pr-0 md:pl-1-2 md:pr-1-2 first:pl-0 last:pr-0': ''} max-h-variable max-w-variable`}>
                      <Snippets.Image
                        alt={`blog featured image ${i}`}
                        src={imageSrc}
                        ratio={'natural'}
                      />
                    </div> 
                    : null
                  }

                  <Snippets.RichText size={'p'} className={'mt-3'}>
                    { content }
                  </Snippets.RichText>
                </div>
              )})}
          </div>
        </div>
      </section>
    )
  }
  
}

export namespace BeautyInMaking {
  export interface Options extends ShopifyNext.Section {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: BeautyInMaking.Options;
  }
  export interface ImageSettings {
    src: string;
  }
  export interface State {}
}